import { Download, Calendar, Heart } from "lucide-react";

export default function HowItWorks() {
	const steps = [
		{
			number: "01",
			icon: <Download size={22} />,
			title: "Download & Sign Up",
			description:
				"Download the Dawi app and create your account in seconds. Choose if you're a patient, guardian, or healthcare professional.",
		},
		{
			number: "02",
			icon: <Calendar size={22} />,
			title: "Browse & Book",
			description:
				"Search for healthcare services, browse qualified professionals, and book appointments at your convenience.",
		},
		{
			number: "03",
			icon: <Heart size={22} />,
			title: "Receive Care",
			description:
				"Get professional medical care at home or in a clinic. Track your health, medications, and appointments easily.",
		},
	];

	return (
		<section id="how-it-works" className="w-full" style={{ backgroundColor: "#f0fafa" }}>
			<div className="max-w-6xl mx-auto px-6 py-20 flex flex-col gap-12">

				{/* Header */}
				<div className="flex flex-col items-center text-center gap-3">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
						How It Works
					</h2>
					<p className="text-gray-400 text-base">
						Get started in three simple steps
					</p>
				</div>

				{/* Steps */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
					{steps.map((step, index) => (
						<div key={step.number} className="relative flex items-center">

							{/* Card */}
							<div className="bg-white rounded-3xl p-8 flex flex-col gap-4 shadow-sm border border-gray-100 w-full">
								{/* Step Number */}
								<span
									className="text-5xl font-bold leading-none select-none"
									style={{ color: "#2C8C87", opacity: 0.25 }}
								>
									{step.number}
								</span>

								{/* Icon */}
								<div
									className="w-11 h-11 rounded-xl flex items-center justify-center"
									style={{ backgroundColor: "#b2ebf2", color: "#2C8C87" }}
								>
									{step.icon}
								</div>

								{/* Text */}
								<div className="flex flex-col gap-2">
									<h3 className="text-base font-bold text-gray-900">{step.title}</h3>
									<p className="text-sm text-gray-400 leading-relaxed">{step.description}</p>
								</div>
							</div>

							{/* Arrow between cards */}
							{index < steps.length - 1 && (
								<div
									className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 items-center justify-center w-8 h-8"
									style={{ color: "#76C7C0" }}
								>
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
										<path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</section>
	);
}